// Public types for the set-status flow. Mirrors the iOS / Android
// `SetStatus*` enums one-to-one.

export type StatusVariation = 'emojiTextDuration' | 'emojiText' | 'textOnly' | 'emojiOnly' | 'none';

export interface UserStatus {
  readonly variation: StatusVariation;
  readonly emoji?: string;
  readonly text?: string;
  readonly expiresAt?: Date;
  readonly setAt: Date;
}

export type StatusDurationPreset =
  | 'thirtyMinutes'
  | 'oneHour'
  | 'fourHours'
  | 'today'
  | 'thisWeek'
  | 'custom';

export const STATUS_DURATION_PRESETS: ReadonlyArray<StatusDurationPreset> = [
  'thirtyMinutes',
  'oneHour',
  'fourHours',
  'today',
  'thisWeek',
  'custom',
];

/** Maximum characters in the user-input status text. */
export const STATUS_TEXT_SOFT_CAP = 40 as const;

/** Pill rendering: truncate text past this length. */
export const STATUS_PILL_TEXT_TRUNCATE = 12 as const;

/** Default `StatusPill` max width in RN units. */
export const STATUS_PILL_DEFAULT_MAX_WIDTH = 80 as const;
